import { render, staticRenderFns } from "./AccountCertificateFormSSN.vue?vue&type=template&id=f8796fa4&scoped=true&"
import script from "./AccountCertificateFormSSN.vue?vue&type=script&lang=ts&"
export * from "./AccountCertificateFormSSN.vue?vue&type=script&lang=ts&"
import style0 from "./AccountCertificateFormSSN.vue?vue&type=style&index=0&id=f8796fa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8796fa4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
